import { useAuth0 } from "@auth0/auth0-react";
import { Authorization_V1 } from "@rw1/auto-generated-clients";
import { useAppConfig, useEnvConfig } from "rwo-react";
import { setAccessTokenProvider } from "./accessTokenProvider";
import { joinUrl } from ".";

let authorizationClientV1: Authorization_V1.AuthorizationClientV1 | undefined;

export const useAuthorizationServiceV1 =
  (): Authorization_V1.AuthorizationClientV1 => {
    const { getAccessTokenSilently } = useAuth0();
    const { backendAddress } = useEnvConfig();
    const { config } = useAppConfig();

    authorizationClientV1 ??= new Authorization_V1.AuthorizationClientV1(
      joinUrl(backendAddress, config["AuthorizationApiSuffix"]),
    );
    setAccessTokenProvider(authorizationClientV1, getAccessTokenSilently);

    return authorizationClientV1;
  };
